import React, { memo } from 'react'
import { FormikRichTextEditor } from 'src/components/shared/form/formik/FormikRichTextEditor'
import { SectionCard } from 'src/components/shared/SectionCard'
import type { CustomerSettingsFormValues } from './CustomerSettingsForm.interface'

interface Props {
  isReadOnly: boolean
}

const DocumentReviewCardComponent = ({ isReadOnly }: Props) => {
  return (
    <SectionCard
      title="Document review"
      subtitle="Instructions shown to staff reviewing this customer's internal documents."
    >
      <FormikRichTextEditor<CustomerSettingsFormValues>
        name="internalDocumentReviewInstructions"
        label="Internal documents review instructions"
        readOnly={isReadOnly}
      />
    </SectionCard>
  )
}

export const DocumentReviewCard = memo(DocumentReviewCardComponent)
